import { atom } from "@mongez/react-atom";

export const filtersParamsAtom: any = atom<URLSearchParams>({
  key: "filtersParams",
  default: {},
});
